export const GOOGLE_PLAY_STORE_APP_URL =
  'https://play.google.com/store/apps/details?id=com.affecttherapeutics';
export const APPLE_APP_STORE_APP_URL =
  'https://apps.apple.com/us/app/affect-addiction-recovery/id1582444280';
